import AlertsApi from "../../../api/alerts-api";
import EventsApi from "../../../api/events-api";
import { AlertTypes } from "../../../constants/alert_types";
import UtilsService from "../../../services/UtilsService";

export default {
  name: "ModifyNote",

  props: {
    note: Object,
    isModalOpen: Boolean,
    reload: Function,
    modalName: String,
  },

  data() {
    return {
      date: new Date(),
      text: null,

      errors: {},
      serverError: null
    };
  },
  methods: {
    async save() {
      // Define the data to send
      const dataToSend = {
        note: this.text
      };

      // Set loading and wait for data to be sent and response to be returned.
      const response = await EventsApi.put(this.note.id, dataToSend)

      // Handle response
      if (response.status === 200) {
        // Success: close and reload
        this.reload();
        this.close();
      } else if (response.status === 400) {
        // Failed: Invalid request
        if (typeof response.data === 'object')
          // swagger error (unreadable)
          this.serverError = {
            error: 'Bad request',
            message: 'Invalid url'
          };
        else
          this.serverError = {
            error: 'Bad request',
            message: response.data
          };

      } else {
        // Failed: server error
        this.serverError = {
          error: 'An error occured',
          message: 'Something went wrong'
        }
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/modify-note/modify-note.js